module.exports = __webpack_public_path__ + "img/yywy-3.3a648b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/yywy-3.jpg
// module id = oaEu
// module chunks = 0